import React from 'react';
import './App.css';

function Default() {
    return (
        <div className="default">
            <h1>No Page Found</h1>
        </div>
    )
}

export default Default
